import {
    UNION_LIST_PARTNER_SUCESS,
    UNION_LIST_PARTNER_FAILED,
    RESET_UNION_LIST_PARTNER,
    LOADING_UNION_LIST_PARTNER,
    NETWORK_ERROR_UNION_LIST_PARTNER
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetunionistPartner = () => {
    return { type: RESET_UNION_LIST_PARTNER };
};

const unionListPartner = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UNION_LIST_PARTNER });
    await partnerServices
        .post("unionListPartner", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "Success":
                    dispatch({ type: UNION_LIST_PARTNER_SUCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: UNION_LIST_PARTNER_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_UNION_LIST_PARTNER,
                payload: err
            });
        });
};

export { resetunionistPartner, unionListPartner };
